<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br />
    <span>{{ "LBL_CONSULTANDO" | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
        <p-accordionTab header="{{ 'USUARIOCOMISIONFREELANCE.LBL_INFORMACIONGENERAL' | translate }}"
          [selected]="tabSeleccionado === 'INFO'">
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="formulario" name="formulario">
            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ "USUARIOCOMISIONFREELANCE.LBL_USUARIOFREELANCE" | translate }}</label>
                  <p-dropdown disableTab  id="idUsuarioFreelance" name="nomIdUsuarioFreelance" [options]="lisUsuariosFreelance"
                    placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                              filter="filter"
                              optionValue="value"
                              optionLabel="label"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                    formControlName="idUsuarioFreelance" *ngIf="!comisionFreelance">
                  </p-dropdown>
                  <div *ngIf="comisionFreelance">
                    <label class="falso-combo-texto">{{comisionFreelance.usuarioSistema}}</label>
                  </div>
                  <div class="p-message p-messages-error p-corner-all"
                    *ngIf="submitted && f.idUsuarioFreelance.invalid">
                    {{ "USUARIOCOMISIONFREELANCE.LBL_USUARIOFREELANCE" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ "USUARIOCOMISIONFREELANCE.LBL_COMISION" | translate }}</label>
                  <input autocomplete="false" formControlName="porcentajeComision" name="porcentajeComision"
                    id="idPorcentajeComision" [maxlength]="5" porcentaje-reactive pInputText [maximo]="100"
                    [decimales]="2" class="campo-porcentaje" />
                  <div class="p-message p-messages-error p-corner-all"
                    *ngIf="submitted && f.porcentajeComision.invalid">
                    {{ "USUARIOCOMISIONFREELANCE.LBL_COMISION" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-4 lg:col-4">
                <div class="div-form">
                  <label>* {{ "USUARIOCOMISIONFREELANCE.LBL_BASE" | translate }}</label>
                  <p-dropdown disableTab  id="baseFreelance" name="nomBaseFreelance" [options]="lisBasesFreelance"
                    placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                    formControlName="idBaseFreelance">
                  </p-dropdown>
                  <div class="p-message p-messages-error p-corner-all"
                    *ngIf="submitted && f.idBaseFreelance.invalid">
                    {{ "USUARIOCOMISIONFREELANCE.LBL_BASE" | translate }}
                    {{ "LBL_REQUERIDO" | translate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-4 lg:col-6">
                <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                            id="indicador"
                            name="nomIndicador"
                            formControlName="indicadorHabilitado"></p-checkbox>
              </div>
            </div>


            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{
                    "BTN_CANCELAR" | translate
                  }}</a>
                  <button icon="fa fa-floppy-o" label="{{ 'BTN_GUARDAR' | translate }}" type="submit" pButton></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
                  <span>{{ "LBL_GUARDANDO" | translate }}</span>
                </div>
              </div>
            </div>
          </form>
        </p-accordionTab>
        <p-accordionTab header="{{ 'USUARIOCOMISIONFREELANCE.LBL_TARIFA' | translate }}"
          [selected]="tabSeleccionado === 'TARIF'" [disabled]="!comisionFreelance">
          <app-comision-freelance-tarifa [comisionFreelance]="comisionFreelance"
            *ngIf="comisionFreelance && comisionFreelance.idUsuarioComisionFreelance"></app-comision-freelance-tarifa>
        </p-accordionTab>
      </p-accordion>
      <div class="grid form-footer-buttons" *ngIf="comisionFreelance && comisionFreelance.idUsuarioComisionFreelance">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button" pButton
            (click)="regresar(false)"></button>
        </div>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
